/**
 * Whether a block is being rendered on the storefront rather than in the Peracto content editor.
 * Safe during server-side rendering, where there is no `window` (and a server render is always the
 * storefront). `window?.x` does not help there: optional chaining still throws for an undeclared global.
 */
export const isInStorefront = () =>
    typeof window === 'undefined' || !window.location.pathname.includes('/content/edit/')

/** The URL hash, or '' during server-side rendering. */
export const getLocationHash = () => (typeof window === 'undefined' ? '' : window.location.hash)
